import { render, staticRenderFns } from "./webexpense_cliam.vue?vue&type=template&id=b577545c&scoped=true"
import script from "./webexpense_cliam.vue?vue&type=script&lang=js"
export * from "./webexpense_cliam.vue?vue&type=script&lang=js"
import style0 from "./webexpense_cliam.vue?vue&type=style&index=0&id=b577545c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577545c",
  null
  
)

export default component.exports